export const SLIDE_DISTANCE = '3.125rem'
